import React from 'react';
import SoftwarePortfolios from './software/softwarePortfolios';
import DesignPortfolios from './design/designPortfolios';

import { Routes, Route } from "react-router-dom";

function Portfolios() {
    return (
        <Routes>
            <Route path="/software" element={<SoftwarePortfolios/>}/>
            <Route path="/design" element={<DesignPortfolios/>}/>
        </Routes>
    );
}

export default Portfolios;